export const state = {
  isAuthenticated: localStorage.getItem('apiToken') ? true : false,
  userInfo: {},
};
